import { Box } from '@mui/material'

const HorizontalSpacer = () => {
    return <Box sx={{ margin: '0 auto' }}></Box>
}

export default HorizontalSpacer
